import React, { useState } from 'react';
import ListFinanceCategories from './ListFinanceCategories.js';
import AddFinanceCategory from './AddFinanceCategory.js';
import { ListButton, AddButton, FAB } from '../../shared/ActionButtons';

export const FinanceCategories = ({ screen, setScreen, hideHeader }) => {
  const [localScreen, setLocalScreen] = useState('list');
  const currentScreen = screen !== undefined ? screen : localScreen;
  const setCurrentScreen = setScreen || setLocalScreen;

  return (
    <>
      {!hideHeader && (
        <div className="content-header">
          <div className="action-buttons">
            <ListButton isActive={currentScreen === 'list'} onClick={() => setCurrentScreen('list')} />
            <AddButton isActive={currentScreen === 'add'} onClick={() => setCurrentScreen('add')} />
          </div>
        </div>
      )}
      {currentScreen === 'list' && <ListFinanceCategories />}
      {currentScreen === 'list' && <FAB onClick={() => setCurrentScreen('add')} />}
      {currentScreen === 'add' && (
        <AddFinanceCategory onSuccess={() => setCurrentScreen('list')} />
      )}
    </>
  );
};

export const FinanceCategoriesActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton isActive={screen === 'list'} onClick={() => setScreen('list')} />
    <AddButton isActive={screen === 'add'} onClick={() => setScreen('add')} />
  </div>
);

export default FinanceCategories;
